import React, { useRef } from "react";
import { Button, Card, Divider, Tabs } from "antd";
import CheckForm from "./CheckForm";
import CheckDetailList from "./CheckDetailList";
import { ProfileTwoTone } from "@ant-design/icons";
import { useModel, useModelDispatchers } from "../../../models"
import { CM_ACTION_TYPE, DICT_KEY, getDictNameByCode, ENV } from "../../../utils/constants";
import { useHistory } from "react-router";
import { goPage } from "../../layout/pageDefinition";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

export default function () {
    const formRef = useRef();
    // const printRef = useRef();

    const { closeNav } = useModelDispatchers("nav");
    const [{ check }, { disable, finish }] = useModel("stockCheck");
    const history = useHistory();
    const onSave = () => {
        formRef.current.update();
    }


    const onBack = () => {
        closeNav();
        goPage(history, "4-2");
    }
    const onDisable = () => {
        disable({ data: check.id });
    }
    const onFinish = () => {
        finish({ data: check.id });
    }

    const Title = () => {
        return (
            <div style={{ display: "flex" }}>
                <h3 style={{ flex: "1" }}>
                    <ProfileTwoTone />
                    <span className="margin-left-8">盘库单号</span>
                    <span className="margin-left-16">
                        {check.inventoryListCode}
                        [{check.orderStatus}-{getDictNameByCode(DICT_KEY.CM_DICT.STOCK_CHECK_STATUS, check.orderStatus)}]
                    </span>
                </h3>
                <div style={{ width: "500px", textAlign: "right" }}>

                    {/*<Button
                        className="margin-left-8"
                        onClick={onPrint}
                    >
                        打印
                    </Button>*/}
                    <YhAuth resCode={ResourceAuthEnum.ST_STTAKE_ED_CANCEL}>
                        <Button
                            className="margin-left-8"
                            onClick={onDisable}
                            disabled={
                                check.orderStatus === "031003"//禁用
                                || check.orderStatus === "031002"//已完成
                            }
                        >
                            作废
                    </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.ST_STTAKE_ED_FINISH}>
                        <Button
                            className="margin-left-8"
                            onClick={onFinish}
                            disabled={
                                check.orderStatus === "031003"//禁用
                                || check.orderStatus === "031002"//已完成
                            }
                        >
                            完成
                    </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.ST_STTAKE_ED_SAVE}>
                        <Button
                            type="primary"
                            className="margin-left-8"
                            onClick={onSave}
                            disabled={
                                check.orderStatus === "031003"//禁用
                                || check.orderStatus === "031002"//已完成
                            }
                        >
                            保存
                    </Button>
                    </YhAuth>
                    <Button
                        className="margin-left-8"
                        onClick={onBack}
                    >
                        返回
                    </Button>
                </div>
            </div>
        )
    }
    return (
        <Card
            title={<Title />}
            bordered={true}
            className="margin-top-8"
        >
            <CheckForm formRef={formRef} actionType={CM_ACTION_TYPE.EDIT} />
            <Divider orientation="left" />
            <CheckDetailList />
            {/*<CheckPrint printRef={printRef}/>*/}
        </Card>
    );
}